//import React, {useState} from 'react'
import React from 'react'

import Front from './Front.js';
import Propuesta from './Propuesta.js';
import Acreditaciones from './Acreditaciones.js';
import AnimationIni from './AnimationIni.js';

function Main() {
	return (
		<>
			<div id="main">
			<AnimationIni/>
				<Front/>
        <Propuesta/>
        <Acreditaciones/>
      </div>
		</>
	)
}

export default Main

